import axios from "axios";

const url = "/api/auth";

export const authenticate = (username, password) =>
  axios.post(url, { username, password }).then(
    (res) => {
      const { user, tokenExpiresAt } = res.data;
      return { user, tokenExpiresAt };
    },
    (error) => {
      //const { status } = error.response || {};
      const message = error.response.data.message;
      throw new Error(message);
    }
  );

export const deauthenticate = () => axios.delete(url);

export const getGuestToken = async (appointmentId, recipientId) => {
  const result = await axios.get("/api/auth/guest-token", {
    params: { appointmentId, recipientId },
  });
  return result.data;
};

export const refreshToken = async (appointmentId) => {
  const result = await axios.put(url, { appointmentId });
  const { user, tokenExpiresAt } = result.data;
  return { user, tokenExpiresAt };
};
